import { FC } from 'react'

import { Box, Step, StepLabel, Stepper } from '@mui/material'
import { t } from 'i18next'

export interface IProps {
  activeStep: number
}
const AvatarStepper: FC<IProps> = ({ activeStep }) => {
  const steps = [
    {
      label: t('common.face'),
    },
    {
      label: t('common.details'),
    },
    {
      label: t('common.finish'),
    },
  ]

  return (
    <Box sx={{ maxWidth: 400, height: '100%', padding: '1rem' }}>
      <Stepper activeStep={activeStep} orientation='vertical' sx={{ height: '100%' }}>
        {steps.map((step, index) => (
          <Step key={step.label} sx={{ height: '5rem' }}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}

export default AvatarStepper
